import angular from 'angular';
import isUrl from 'is-url';
import { first } from 'rxjs/operators';

function setSrcAttributeWithJwt(element, url, LoginFactory) {
  const cdnStartPattern = 'cdn';
  if (url) {
    let u = new URL(url);
    // don't add jwt if url is cdn
    if (u.hostname.startsWith(cdnStartPattern)) {
      element.attr('src', url);
    } else {
      LoginFactory.getJwtShort()
        .pipe(first())
        .subscribe((jwtShort) => {
          u.searchParams.set('jwt', jwtShort);
          element.attr('src', u.toString());
        });
    }
  } else if (element.attr('err-src')) {
    element.attr('src', element.attr('err-src'));
  }
}

jwtSrc.$inject = ['LoginFactory'];
function jwtSrc(LoginFactory) {
  return {
    scope: {
      jwtSrc: '@'
    },
    link: function ($scope, elem, attrs) {
      attrs.$observe('jwtSrc', url => setSrcAttributeWithJwt(elem, url, LoginFactory));
    }
  };
}

profileInfos.$inject = [];
function profileInfos() {
  return {
    template: angular.element('#profile_html').text()
  };
}

customLoading.$inject = [];
function customLoading() {
  return {
    template: angular.element('#loading_html').text()
  };
}

fileread.$inject = ['$timeout'];
function fileread($timeout) {
  // We use this because ng-model does not work with file input type:
  // https://stackoverflow.com/questions/17063000/ng-model-for-input-type-file
  return {
    restrict: 'A',
    scope: {
      fileread: '='
    },
    link: function (scope, element, attributes) {
      function validate() {
        if (element.context.form && attributes.required) {
          angular.element(element.context.form).controller("form").$setValidity('required', element.val().trim() != '');
        }
      }

      validate();

      // use $timeout to prevent « $apply already in progress » error in IE11.
      // ( see https://stackoverflow.com/questions/12729122/angularjs-prevent-error-digest-already-in-progress-when-calling-scope-apply )
      element.on('change.fileread',
        changeEvent => $timeout(() => {
          validate();
          scope.fileread = changeEvent.target.files[0];
        }));
      scope.$on('$destroy', () => element.off('change.fileread'));
    }
  };
}

stricterUrl.$inject = [];
function stricterUrl() {
  // cf https://docs.angularjs.org/guide/forms#custom-validation
  return {
    require: '?ngModel',
    link: function (scope, elm, attrs, ctrl) {
      // only apply the validator if ngModel is present and AngularJS has added the url validator
      if (ctrl && ctrl.$validators.url) {

        // this will overwrite the default AngularJS url validator
        ctrl.$validators.url = function (modelValue) {
          return ctrl.$isEmpty(modelValue) || (isUrl(modelValue) && (modelValue.split(':')[0] === 'http' || modelValue.split(':')[0] === 'https')); // Allow only http or https protocol
        };
      }
    }
  };
}

angular.module('app.directives', [])
  .directive('jwtSrc', jwtSrc)
  .directive('profileInfos', profileInfos)
  .directive('customLoading', customLoading)
  .directive('fileread', fileread)
  .directive('stricterUrl', stricterUrl)
  ;

